import Hip from './Template'

export default Hip
